import { createContext } from 'react';

import {
  LocalVideoTrack,
  Participant,
  Stream,
  VideoClient,
} from '@zoom/videosdk';

import { Devices } from 'plugin/virtual-braindate/type/virtualTypes';

type context = {
  zoomSession: typeof Stream | null;
  zoomVideo: { current: typeof VideoClient | null };
  isInitiated: boolean;
  setMediaError: (error: Error | null) => void;
  localTracksState: {
    isAudioEnabled: boolean;
    isVideoEnabled: boolean;
    setIsAudioEnabled: (enabled: boolean) => void;
    setIsVideoEnabled: (enabled: boolean) => void;
  };
  isConnecting: boolean;
  devices: Devices;
  localParticipant: Participant | null;
  ownShareVideoRef: React.MutableRefObject<HTMLVideoElement | null>;
  ownShareCanvasRef: React.MutableRefObject<HTMLCanvasElement | null>;
  otherShareCanvasRef: React.MutableRefObject<HTMLCanvasElement | null>;
  activeSharingId: Number | null;
  isDisplayShareVideo: boolean;
  toggleScreenShare: () => void;
  isSharingScreen: boolean;
  localVideoRef: { current: HTMLVideoElement | null };
  localCanvasRef: { current: HTMLCanvasElement | null };
  cameraRef: { current: LocalVideoTrack | null };
};

const VirtualBraindateZoomContext = createContext<context>({
  zoomSession: null,
  zoomVideo: { current: null },
  setMediaError: () => {},
  isInitiated: false,
  localTracksState: {
    isAudioEnabled: false,
    isVideoEnabled: false,
    setIsAudioEnabled: () => {},
    setIsVideoEnabled: () => {},
  },
  isConnecting: false,
  devices: {
    micList: [],
    speakerList: [],
    cameraList: [],
    activeMicrophone: null,
    activeSpeaker: null,
    activeCamera: null,
    setActiveMicrophone: () => {},
    setActiveSpeaker: () => {},
    setActiveCamera: () => {},
  },
  localParticipant: null,
  ownShareVideoRef: { current: null },
  ownShareCanvasRef: { current: null },
  otherShareCanvasRef: { current: null },
  activeSharingId: null,
  isDisplayShareVideo: false,
  toggleScreenShare: () => {},
  isSharingScreen: false,
  isBlur: false,
  setActiveMicrophone: () => {},
  setActiveSpeaker: () => {},
  setActiveCamera: () => {},
  onBlurSwitchClick: () => {},
  localVideoRef: {
    current: null,
  },
  localCanvasRef: {
    current: null,
  },
  cameraRef: {
    current: null,
  },
});

export default VirtualBraindateZoomContext;
